module.exports = __webpack_public_path__ + "img/equipmnet-tracking-depth.bf183b33.webp";